<template>
  <div class="rv-wrap">
    <div class="rv-scroll-x">
      <table class="rv-table">
        <thead>
          <tr>
            <th class="rv-th-room">房间</th>
            <th
              v-for="day in weekDays"
              :key="day.date"
              class="rv-th-day"
              :class="{ 'rv-today-col': day.date === todayStr }">
              <span class="rv-week">{{ day.weekLabel }}</span>
              <span class="rv-date" :class="{ 'rv-today': day.date === todayStr }">{{ day.dayLabel }}</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="!roomList.length">
            <td :colspan="weekDays.length + 1" class="rv-empty">暂无房间数据</td>
          </tr>
          <tr v-for="room in roomList" :key="room.roomId" class="rv-row">
            <td class="rv-td-room">
              <div class="rv-room-no">{{ room.roomNo }}</div>
              <div class="rv-room-sub">{{ room.floorNo }}楼 · {{ room.bedNum }}床</div>
            </td>
            <td
              v-for="day in weekDays"
              :key="day.date"
              class="rv-td-cell"
              :class="{
                'rv-cell-warn': day.date <= todayStr && shiftList.some(s => !getShiftStaff(room.roomId, day.date, s.id).length),
                'rv-cell-weekend': isWeekend(day.date)
              }"
              @click="openDetail(room, day.date, null)">
              <div class="rv-cell-inner">
                <template v-for="shift in shiftList">
                  <div
                    v-if="getShiftStaff(room.roomId, day.date, shift.id).length"
                    :key="'has-' + shift.id"
                    class="rv-shift-row"
                    :style="{ borderLeft: '3px solid ' + (shift.color || '#2563EB'), background: hexToLight(shift.color) }"
                    @click.stop="openDetail(room, day.date, shift.id)">
                    <span class="rv-shift-badge" :style="{ background: shift.color || '#2563EB' }">
                      {{ shift.name ? shift.name.charAt(0) : '' }}
                    </span>
                    <div class="rv-avatars">
                      <span
                        v-for="(s, idx) in getShiftStaff(room.roomId, day.date, shift.id).slice(0, 4)"
                        :key="s.id"
                        class="rv-avatar-stack"
                        :style="{ background: shift.color || '#2563EB', marginLeft: idx === 0 ? '0' : '-6px', zIndex: 4 - idx }"
                        :title="s.staffName">
                        {{ s.staffName ? s.staffName.charAt(0) : '' }}
                      </span>
                      <span v-if="getShiftStaff(room.roomId, day.date, shift.id).length > 4" class="rv-avatar-more">
                        +{{ getShiftStaff(room.roomId, day.date, shift.id).length - 4 }}
                      </span>
                    </div>
                    <span class="rv-staff-count">{{ getShiftStaff(room.roomId, day.date, shift.id).length }}人</span>
                  </div>
                  <div
                    v-else-if="day.date <= todayStr"
                    :key="'miss-' + shift.id"
                    class="rv-shift-missing"
                    @click.stop="$emit('add', { date: day.date, shiftId: shift.id, shiftName: shift.name, shiftColor: shift.color, isQuickFill: true })">
                    <span class="rv-missing-badge" :style="{ background: shift.color || '#2563EB' }">
                      {{ shift.name ? shift.name.charAt(0) : '' }}
                    </span>
                    <span class="rv-missing-text">缺{{ shift.name }}</span>
                    <i class="el-icon-plus" style="font-size:11px;color:#D97706;flex-shrink:0"></i>
                  </div>
                </template>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 详情弹窗 -->
    <el-dialog
      :visible.sync="detailVisible"
      :show-close="false"
      :append-to-body="true"
      width="620px"
      custom-class="rv-detail-dialog">
      <div class="d-modal">
        <div class="d-header">
          <div class="d-header-left">
            <div class="d-title-row">
              <span class="d-title">{{ detailShiftId ? '班次排班详情' : '当日排班详情' }}</span>
              <span class="d-shift-badge" :style="{ background: detailShiftColor + '22', color: detailShiftColor }">
                {{ detailShiftName }} {{ detailShiftTime }}
              </span>
            </div>
            <div class="d-sub-row">
              <i class="el-icon-date" style="color:#64748B;flex-shrink:0"></i>
              <span>{{ detailWeekLabel }} {{ detailDate }}</span>
              <span class="d-sep">·</span>
              <i class="el-icon-house" style="color:#64748B;flex-shrink:0"></i>
              <span>共涉及 {{ totalRoomCount }} 间房</span>
              <span class="d-sep">·</span>
              <i class="el-icon-user" style="color:#64748B;flex-shrink:0"></i>
              <span>{{ detailSchedules.length }} 位护工</span>
            </div>
          </div>
          <div class="d-close-btn" @click="detailVisible = false">
            <i class="el-icon-close" style="color:#94A3B8;font-size:16px"></i>
          </div>
        </div>
        <div class="d-body">
          <el-table :data="detailSchedules" size="small" :border="false" style="width:100%">
            <el-table-column type="index" label="#" width="44" align="center"></el-table-column>
            <el-table-column label="护工" width="130">
              <template slot-scope="{ row }">
                <div style="display:flex;align-items:center;">
                  <span class="d-avatar" :style="{ background: getShiftColor(row.shiftId) + '33', color: getShiftColor(row.shiftId) }">
                    {{ row.staffName ? row.staffName.charAt(0) : '' }}
                  </span>
                  <span style="margin-left:8px;font-weight:500">{{ row.staffName }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="岗位" width="80">
              <template slot-scope="{ row }">
                <span style="color:#64748B">{{ row.deptName || '护理员' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="负责房间">
              <template slot-scope="{ row }">
                <span v-for="r in (row.roomList || [])" :key="r.roomId" class="d-room-tag">{{ r.roomNo }}</span>
              </template>
            </el-table-column>
            <el-table-column label="房间数" width="60" align="center">
              <template slot-scope="{ row }">
                <span class="d-count-badge">{{ row.roomList ? row.roomList.length : 0 }}</span>
              </template>
            </el-table-column>
          </el-table>
          <div class="d-sum-row">
            <span>合计 {{ detailSchedules.length }} 人</span>
            <span style="margin-left:16px">共覆盖 {{ totalRoomCount }} 间房（{{ allRoomNos }}）</span>
          </div>
        </div>
        <div class="d-footer">
          <el-button size="small" @click="$emit('edit', detailSchedules[0])">
            <i class="el-icon-edit"></i> 编辑排班
          </el-button>
          <el-button size="small" @click="$emit('add', { date: detailDate })">
            <i class="el-icon-plus"></i> 新增护工
          </el-button>
          <el-button type="primary" size="small" @click="detailVisible = false">关闭</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { hexToLight } from '../scheduleUtils'

export default {
  name: 'RoomView',
  props: {
    scheduleList: { type: Array, default: () => [] },
    roomList: { type: Array, default: () => [] },
    shiftList: { type: Array, default: () => [] },
    weekDays: { type: Array, default: () => [] },
    todayStr: { type: String, default: '' }
  },
  data() {
    return {
      detailVisible: false,
      detailRoom: null,
      detailDate: '',
      detailShiftId: null
    }
  },
  computed: {
    roomScheduleMap() {
      const map = {}
      for (const s of this.scheduleList) {
        for (const r of (s.roomList || [])) {
          if (!map[r.roomId]) map[r.roomId] = {}
          const d = s.date ? s.date.substring(0, 10) : ''
          if (!map[r.roomId][d]) map[r.roomId][d] = []
          map[r.roomId][d].push(s)
        }
      }
      return map
    },
    detailSchedules() {
      const all = this.getCellData(this.detailRoom ? this.detailRoom.roomId : null, this.detailDate)
      if (this.detailShiftId === null) return all
      return all.filter(s => String(s.shiftId) === String(this.detailShiftId))
    },
    detailShiftName() {
      return this.detailSchedules.length ? (this.detailSchedules[0].shiftName || '') : ''
    },
    detailShiftColor() {
      return this.detailSchedules.length ? this.getShiftColor(this.detailSchedules[0].shiftId) : '#2563EB'
    },
    detailShiftTime() {
      if (!this.detailSchedules.length) return ''
      const s = this.shiftList.find(x => String(x.id) === String(this.detailSchedules[0].shiftId))
      return s ? s.time : ''
    },
    detailWeekLabel() {
      if (!this.detailDate) return ''
      const labels = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
      return labels[new Date(this.detailDate).getDay()]
    },
    totalRoomCount() {
      const ids = new Set()
      this.detailSchedules.forEach(s => (s.roomList || []).forEach(r => ids.add(r.roomId)))
      return ids.size
    },
    allRoomNos() {
      const nos = []
      this.detailSchedules.forEach(s => (s.roomList || []).forEach(r => {
        if (!nos.includes(r.roomNo)) nos.push(r.roomNo)
      }))
      if (nos.length <= 6) return nos.join('、')
      return nos.slice(0, 6).join('、') + `等${nos.length}间`
    }
  },
  methods: {
    hexToLight,
    getCellData(roomId, date) {
      if (!roomId || !date) return []
      return (this.roomScheduleMap[roomId] && this.roomScheduleMap[roomId][date]) || []
    },
    getShiftStaff(roomId, date, shiftId) {
      return this.getCellData(roomId, date).filter(s => String(s.shiftId) === String(shiftId))
    },
    getShiftColor(shiftId) {
      const s = this.shiftList.find(x => String(x.id) === String(shiftId))
      return s ? (s.color || '#2563EB') : '#2563EB'
    },
    isWeekend(date) {
      const d = new Date(date).getDay()
      return d === 0 || d === 6
    },
    openDetail(room, date, shiftId) {
      this.detailRoom = room
      this.detailDate = date
      this.detailShiftId = shiftId
      this.detailVisible = true
    }
  }
}
</script>

<style scoped>
.rv-wrap { flex: 1; min-height: 0; display: flex; flex-direction: column; overflow: hidden; }
.rv-scroll-x { flex: 1; min-height: 0; overflow: auto; }
.rv-table { border-collapse: collapse; width: 100%; min-width: max-content; }
.rv-th-room {
  width: 160px; min-width: 160px; padding: 10px 14px; text-align: left;
  font-size: 13px; font-weight: 600; color: #64748B;
  background: #F8FAFC; border-bottom: 2px solid #E2E8F0; border-right: 1px solid #E2E8F0;
  position: sticky; left: 0; z-index: 3;
}
.rv-th-day {
  min-width: 120px; padding: 10px 14px; text-align: center;
  background: #F8FAFC; border-bottom: 2px solid #E2E8F0; border-right: 1px solid #E2E8F0;
}
.rv-th-day:last-child { border-right: none; }
.rv-today-col { background: #EFF6FF; }
.rv-week { display: block; font-size: 11px; color: #94A3B8; }
.rv-date { display: block; font-size: 13px; font-weight: 600; color: #1E293B; }
.rv-today { color: #2563EB; }
.rv-row td { border-bottom: 1px solid #F1F5F9; }
.rv-td-room {
  width: 160px; min-width: 160px; padding: 10px 14px;
  background: #fff; border-right: 1px solid #E2E8F0; vertical-align: middle;
  position: sticky; left: 0; z-index: 1;
}
.rv-room-no { font-size: 13px; font-weight: 600; color: #1E293B; }
.rv-room-sub { font-size: 11px; color: #94A3B8; margin-top: 2px; }
.rv-td-cell {
  min-width: 120px; padding: 6px 8px; vertical-align: top;
  border-right: 1px solid #F1F5F9; cursor: pointer; height: 1px;
}
.rv-td-cell:last-child { border-right: none; }
.rv-td-cell:hover { background: #F8FAFC; }
.rv-cell-warn { background: #FFFBEB; }
.rv-cell-weekend { background: #FAFAFA; }
.rv-cell-inner { display: flex; flex-direction: column; min-height: 56px; height: 100%; }
.rv-cell-inner > * { margin-bottom: 3px; }
.rv-shift-row {
  display: flex; align-items: center;
  padding: 5px 8px; border-radius: 6px; cursor: pointer;
}
.rv-shift-row:hover { opacity: 0.85; }
.rv-shift-badge {
  width: 18px; height: 18px; border-radius: 4px; flex-shrink: 0;
  color: #fff; font-size: 11px; font-weight: 700;
  display: flex; align-items: center; justify-content: center;
  margin-right: 6px;
}
.rv-avatars { display: flex; align-items: center; flex: 1; }
.rv-avatar-stack {
  width: 20px; height: 20px; border-radius: 50%; flex-shrink: 0;
  color: #fff; font-size: 10px; font-weight: 700;
  display: flex; align-items: center; justify-content: center;
  border: 1.5px solid #fff;
}
.rv-avatar-more { font-size: 10px; color: #64748B; margin-left: 2px; white-space: nowrap; }
.rv-staff-count { font-size: 11px; font-weight: 600; color: #475569; white-space: nowrap; flex-shrink: 0; }
.rv-shift-missing {
  display: flex; align-items: center;
  padding: 4px 8px; border-radius: 6px; cursor: pointer;
  background: #FFFBEB; border: 1px dashed #FCD34D;
}
.rv-shift-missing:hover { background: #FEF3C7; }
.rv-missing-badge {
  width: 16px; height: 16px; border-radius: 3px; flex-shrink: 0;
  color: #fff; font-size: 10px; font-weight: 700;
  display: flex; align-items: center; justify-content: center;
  opacity: 0.5; margin-right: 5px;
}
.rv-missing-text { font-size: 11px; color: #D97706; font-weight: 500; flex: 1; }
.rv-empty { padding: 40px; text-align: center; color: #94A3B8; font-size: 13px; }
/* 详情弹窗 */
.d-modal { display: flex; flex-direction: column; }
.d-header {
  display: flex; justify-content: space-between; align-items: flex-start;
  padding: 18px 20px 14px; border-bottom: 1px solid #E2E8F0;
}
.d-header-left { display: flex; flex-direction: column; }
.d-title-row { display: flex; align-items: center; margin-bottom: 6px; }
.d-title { font-size: 16px; font-weight: 600; color: #1E293B; margin-right: 10px; }
.d-shift-badge { padding: 3px 10px; border-radius: 20px; font-size: 12px; font-weight: 500; }
.d-sub-row { display: flex; align-items: center; font-size: 13px; color: #64748B; }
.d-sub-row > * { margin-right: 8px; }
.d-sep { color: #CBD5E1; }
.d-close-btn { width: 30px; height: 30px; border-radius: 6px; cursor: pointer; display: flex; align-items: center; justify-content: center; }
.d-close-btn:hover { background: #F1F5F9; }
.d-body { padding: 14px 20px; }
.d-avatar {
  width: 28px; height: 28px; border-radius: 50%; flex-shrink: 0;
  font-size: 11px; font-weight: 700;
  display: flex; align-items: center; justify-content: center;
}
.d-room-tag { padding: 2px 6px; border-radius: 4px; background: #F1F5F9; color: #475569; font-size: 11px; margin-right: 4px; }
.d-count-badge {
  display: inline-flex; align-items: center; justify-content: center;
  width: 22px; height: 22px; border-radius: 50%;
  background: #DBEAFE; color: #2563EB; font-size: 12px; font-weight: 600;
}
.d-sum-row {
  padding: 10px 0 0; font-size: 12px; color: #64748B;
  border-top: 1px solid #F1F5F9; margin-top: 8px;
}
.d-footer {
  display: flex; justify-content: flex-end;
  padding: 12px 20px; border-top: 1px solid #E2E8F0;
}
.d-footer .el-button { margin-left: 8px; }
</style>

<style>
.rv-detail-dialog .el-dialog__header { display: none; }
.rv-detail-dialog .el-dialog__body { padding: 0; }
</style>
